import { useTenantSettings } from 'react-common'

type FeedbackTenantSettings = {
  learner: {
    visible: boolean
  }
}

export const useFeedbackSettings = () => {
  const feedback = useTenantSettings<FeedbackTenantSettings>('platform.ui.feedback', true)

  const getVisibility = () => {
    try {
      const visible = feedback?.learner?.visible

      if (typeof visible === 'boolean') {
        return visible
      }

      return true
      // in case feedback or learner is not object
    } catch {
      return true
    }
  }

  return {
    visible: getVisibility(),
  }
}
